import React from "react";
import MediaSelectContext from "app/app/mediaSelector/contexts/MediaSelectContext";

export default function useMediaSelect() {
    return React.useContext(MediaSelectContext);
}
